import { DEEP_LINK_PATHS } from '../constant/appLinks';

/**
 * Converts an AASA-style path pattern (e.g. `/listing/*`) to a RegExp.
 */
const patternToRegExp = (pattern: string): RegExp => {
  const normalized = pattern.endsWith('/') ? pattern.slice(0, -1) : pattern;

  if (normalized.endsWith('/*')) {
    const base = normalized.slice(0, -2);
    // Matches /listing, /listing/, /listing/foo, etc.
    return new RegExp(`^${escapeRegExp(base)}(?:/.*)?$`, 'i');
  }

  return new RegExp(`^${escapeRegExp(normalized)}/?$`, 'i');
};

const escapeRegExp = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const DEEP_LINK_REGEXES = DEEP_LINK_PATHS.map(patternToRegExp);

/** True when pathname should be handled as an app deep link (mirrors AASA paths). */
export const isDeepLinkPath = (pathname: string): boolean => {
  if (!pathname || pathname === '/') {
    return false;
  }
  return DEEP_LINK_REGEXES.some((regex) => regex.test(pathname));
};
